@for (itinerary of itineraries; track itinerary) {
  @if (itinerary.segments.length || (!itinerary.segments.length && withHiddenFlightsV2)) {
    @if (itinerary.segments.length) {
      <div data-id="itinerary" class="option-details-wrapper">
        <div class="d-flex flex-column mt-4">
          <h3 class="bold flex-wrap mb-1 align-items-center">
            <span data-id="from">{{ itinerary.departureAirport.cityName }}</span>
            &nbsp;&ndash;&nbsp;
            <span data-id="to">{{ itinerary?.finalDestinationAirport?.cityName }}</span>
          </h3>
          <div class="d-flex align-items-center">
            <p data-id="departure-at" class="pr-4">
              Departure on {{ itinerary.departureAt | date: 'EEE, MMM d' }}
            </p>
            <p data-id="travel-time">Travel time: {{ itinerary.travelTime | travelTime }}</p>
          </div>
        </div>

        <div class="d-flex flex-column mt-4 option-detail">
          @for (segment of itinerary.segments; track segment; let last = $last) {
            <div data-id="itinerary-segment" class="d-flex flex-column option-detail-segment">
              <div class="d-flex align-items-center pb-4">
                <img
                  [src]="segment.flightSegment.airline.logoUrl"
                  alt="airline"
                  class="option-detail-segment-logo"
                />

                <div class="d-flex align-items-center">
                  <p class="d-flex flex-wrap">
                    <span data-id="airline-short-name" class="nowrap">{{
                      segment.flightSegment.airline.shortName
                    }}</span
                    >&nbsp;<span data-id="flight-number">{{
                      segment.flightSegment.flightNumber
                    }}</span
                    ><ng-container *ngIf="segment.flightSegment.operatedBy"
                      ><span class="mx-2"><ds-dot-separator /></span
                      ><span data-id="operated-by" class="nowrap"
                        >Operated by {{ segment.flightSegment.operatedBy }}</span
                      ></ng-container
                    ><ng-container *ngIf="segment.flightSegment.aircraftName"
                      ><span class="mx-2"><ds-dot-separator /></span
                      ><span data-id="aircraft-name" class="nowrap">{{
                        segment.flightSegment.aircraftName
                      }}</span></ng-container
                    >
                  </p>
                </div>
              </div>

              <div class="d-flex flex-column option-detail-segment-container" data-id="leg">
                <div class="d-flex">
                  <div class="d-flex flex-column justify-content-center align-items-center mr-6">
                    <div class="d-flex align-items-center justify-content-center edge-wrapper">
                      <div class="edge"></div>
                    </div>

                    <div class="line h-100"></div>

                    <div class="d-flex align-items-center justify-content-center edge-wrapper">
                      <div class="edge"></div>
                    </div>
                  </div>

                  <div class="d-flex flex-column noscroll">
                    <ng-container
                      *ngTemplateOutlet="
                        flightSegmentTemplate;
                        context: {
                          timeZone: segment.flightSegment.departureAtAirportTimeZone,
                          airport: segment.flightSegment.departureAirport,
                        }
                      "
                    />

                    <div class="d-flex mt-5">
                      <p data-id="travel-time" class="option-detail-segment-left-bloc mr-5">
                        {{ segment.travelTime | travelTime }}
                      </p>
                      <p data-id="travel-service-class">
                        {{ segment.flightSegment.serviceClass | label }} ({{
                          segment.flightSegment.airlineServiceClass
                        }})
                      </p>
                    </div>

                    @if (segment.flightSegment.isOvernight) {
                      <div class="d-flex mt-2">
                        @if (segment.flightSegment.isOvernight) {
                          <div data-id="isOvernight" class="mr-1">
                            <flight-badge
                              [type]="flightBadgeType.Sun"
                              title="Overnight flight"
                              icon="nights_stay"
                            />
                          </div>
                        }
                        @if (false) {
                          <!--              add logic after backend changes-->
                          <div data-id="upgrade-applied">
                            <flight-badge
                              [type]="flightBadgeType.Green"
                              title="Upgrade applied"
                              icon="shift"
                            />
                          </div>
                        }
                      </div>
                    }

                    <div class="mt-5">
                      <ng-container
                        *ngTemplateOutlet="
                          flightSegmentTemplate;
                          context: {
                            timeZone: segment.flightSegment.arrivalAtAirportTimeZone,
                            airport: segment.flightSegment.arrivalAirport,
                            isNextDay: segment.nextDayArrival,
                          }
                        "
                      />
                    </div>

                    @if (segment.nextDayArrival) {
                      <div data-id="next-day-badge" class="mt-2">
                        <flight-badge
                          [type]="flightBadgeType.Sun"
                          title="You will arrive the next day"
                          icon="flight-land"
                        />
                      </div>
                    }
                  </div>
                </div>

                @if (
                  itinerary?.finalDestinationAirport?.locationCode ===
                    itinerary.arrivalAirport.locationCode && segment.layover
                ) {
                  <div
                    data-id="layover"
                    class="d-flex align-items-start option-detail-segment-layover"
                  >
                    <img class="mr-2" src="assets/icons/airline_stops.svg" alt="airline_stops" />
                    <div class="d-flex flex-column g-1">
                      @let waitTime = segment.layover ? segment.layover.waitTime : null;

                      @if (waitTime) {
                        <p data-id="layover-title">
                          Layover {{ waitTime | travelTime }} in
                          {{ segment.flightSegment.arrivalAirport.cityName }} ({{
                            segment.flightSegment.arrivalAirport.locationCode
                          }})
                        </p>
                      }

                      @if (segment.layover.selfTransfer) {
                        <p class="text-sun-crete-700" data-id="self-transfer">
                          Self-transfer: Just pick up your bags, check in again, and you’re set for
                          the next flight
                        </p>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          } @empty {
            @if (withHiddenFlightsV2) {
              <div data-id="bonus-flight" class="d-flex px-4 px-md-8 py-4">
                <bonus-flight [itinerary]="itinerary" />
              </div>
            }
          }
        </div>
      </div>
    } @else {
      @if (withHiddenFlightsV2) {
        <div class="d-flex px-4 px-md-8 py-4">
          <bonus-flight [itinerary]="itinerary" />
        </div>
      }
    }
  }
}

<ng-template
  #flightSegmentTemplate
  let-timeZone="timeZone"
  let-airport="airport"
  let-isNextDay="isNextDay"
>
  <div class="d-flex flex-column">
    <div class="d-flex">
      <div class="d-flex flex-column mr-5 option-detail-segment-left-bloc noscroll">
        <h3 class="bold mb-1" data-id="departure-at">
          {{ (timeZone | withoutTimezone: 'h:mma' : true).toLowerCase() }}
        </h3>
        <p [class.text-sun-crete-800]="isNextDay" data-id="next-day-departure">
          {{ timeZone | withoutTimezone: 'MMM d' }}
        </p>
      </div>
      <div class="d-flex flex-column noscroll">
        <h3 class="bold mb-1" data-id="departure-city-name">{{ airport.cityName }}</h3>
        <div class="d-flex">
          <p>{{ airport.locationCode }}</p>
          <div class="align-items-center justify-content-center d-flex dot">
            <ds-dot-separator />
          </div>
          <div data-id="departure-location-name" class="text-ellipsis w-100">
            {{ airport.locationName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
